export enum TableType {
    filter = 'filter',
    page = 'page'
}
